// extracted by mini-css-extract-plugin
module.exports = {"heading":"mo6ts","heading-secondary":"KBUsM"};